// extracted by mini-css-extract-plugin
module.exports =  {"modal":"modal__XRTas"};